import http from '@http';
import { download } from '@services/helper.service';

class DocumentService {
    constructor() {
        if (DocumentService.instance) {
            return DocumentService.instance;
        }
        DocumentService.instance = this;
    }

    getIndexData(kindergartenId, queryObj) {
        return http.get(`/api/kindergartens/${kindergartenId}/documents`, {params: queryObj}).then(res => res.data);
    }

    getDocumentData(kindergartenId, fileId) {
        return http.get(`/api/kindergartens/${kindergartenId}/documents/${fileId}`).then(res => res.data);
    }

    getDocument(kindergartenId, file) {
        return http.download(`/api/kindergartens/${kindergartenId}/files/documents/${file.filename}`).then(res => res.data);
    }
    downloadDocument(kindergartenId, file) {
        return this.getDocument(kindergartenId, file).then(document => download(document, file));
    }

    deleteDocument(kindergartenId, filename) {
        return http.delete(`/api/kindergartens/${kindergartenId}/files/documents/${filename}`)
            .then(res => res.data);
    }

    updateActivity(kindergartenId) {
        return http.get(`/api/kindergartens/${kindergartenId}/documents/activity`).then(res => res.data);
    }

    updateDocumentFile(kindergartenId, filename, form) {
        return http.put(`/api/kindergartens/${kindergartenId}/files/documents/${filename}`, form).then(res => res.data);
    }

    getDocumentAcl(kindergartenId, documentId) {
        return http.get(`/api/kindergartens/${kindergartenId}/documents/${documentId}/acl`).then(res => res.data);
    }

    getSharedDocuments(kindergartenId, queryObj) {
        return http.get(`/api/kindergartens/${kindergartenId}/documents/shared`, {params: queryObj}).then(res => res.data);
    }

    lockDocument(kindergartenId, fileId) {
        return http.post(`/api/kindergartens/${kindergartenId}/documents/${fileId}/lock`).then(res => res.data);
    }

    unlockPath(kindergartenId, fileId, lockedAt = null) {
        let path = `/api/kindergartens/${kindergartenId}/documents/${fileId}/lock/release`;
        if (lockedAt) {
            path += `?locked_at=${encodeURIComponent(lockedAt)}`;
        }
        return path;
    }

    unlockDocument(kindergartenId, fileId, lockedAt = null) {
        return http.post(this.unlockPath(kindergartenId, fileId, lockedAt)).then(res => res.data);
    }

    /*
     * Best-effort unlock for page unload. A fetch with a DELETE needs a CORS
     * preflight, which is not reliable once the page is going away, so this
     * sends the release endpoint as a beacon instead. locked_at lets the API
     * ignore the release when the lock has already been taken again.
     */
    releaseLockOnUnload(kindergartenId, fileId, lockedAt) {
        const url = `${process.env.VUE_APP_API_URL}${this.unlockPath(kindergartenId, fileId, lockedAt)}`;
        if (this.sendBeacon(url)) {
            return;
        }

        fetch(url, {
            method: 'POST',
            credentials: 'include',
            keepalive: true
        }).catch(() => {
            /* The page may already be gone, so there is nothing to report. */
        });
    }

    sendBeacon(url) {
        try {
            return !!(navigator.sendBeacon && navigator.sendBeacon(url, new Blob([], {type: 'text/plain'})));
        } catch (e) {
            /* Fall back to a keepalive fetch. */
            return false;
        }
    }

    convertToSfdt(serviceUrl, formData) {
        return http.post(serviceUrl, formData, {headers: {'Content-Type': 'multipart/form-data'}, withCredentials: false}).then(res => res.data);
    }

    patchDocumentFile(kindergartenId, filename, form) {
        return http.post(`/api/kindergartens/${kindergartenId}/files/documents/${filename}`, form).then(res => res.data);
    }
}

export default new DocumentService();
